import React from "react"
import {Col, Container, Row} from "react-bootstrap";
import {getPost, getPosts} from "../../api/api_post";
import EditPost from "../EditPost/EditPost";
import SearchPost from "../SearchPost/SearchPost";
import AllPostsList from "../AllPostsList/AllPostsList";

export default class AllPostsAdmin extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPost: null,
            currentPostId: null,
            currentPage: 1,
            totalPostsNumber: 0,
            totalPages: 0,
            posts: []
        }

        this.clickOnPost = this.clickOnPost.bind(this)
        this.getPosts = this.getPosts.bind(this)
    }

    componentDidMount() {
        this.getPosts()
    }

    getPosts(parameters = {}) {
        parameters = {...parameters, 'order' : {'id' : 'desc'}}
        Promise.all([getPosts(parameters)]).then((promisesResults) => {
            const [posts] = promisesResults

            let totalPages = 1
            if(posts["hydra:view"]['hydra:last'] !== undefined) {
                totalPages = posts["hydra:view"]['hydra:last'].split('=')
                totalPages = totalPages[totalPages.length - 1]
            }


            let state = {
                posts: posts["hydra:member"],
                totalPages: totalPages,
                totalPostsNumber: posts["hydra:totalItems"]
            }

            if (this.state.currentPost === null) {
                state = {...state, 'currentPost': posts["hydra:member"][0], 'currentPostId': posts["hydra:member"][0].id}
            }

            this.setState(state)
        })
    }

    clickOnPost(e) {
        Promise.all([getPost(e.target.dataset.postid)]).then((promisesResults) => {
            const [post] = promisesResults
            this.setState({
                currentPost: post,
                currentPostId: post.id
            }, () => {
                this.getPosts()
            })
        })
    }

    render() {
        let editPost = ''
        if (this.state.currentPost != null) {
            editPost = <EditPost key={this.state.currentPostId} post={this.state.currentPost}
                                 allCategories={this.props.allCategories} allPostOptions={this.props.allPostOptions}/>
        }

        return <Container>
            <Row className="margin-top-75">
                <Col md={4}>
                    {this.state.posts.length} posts (of {this.state.totalPostsNumber}) - Page {this.state.currentPage}/{this.state.totalPages}
                    <SearchPost searchFunction={this.getPosts}/>
                    <AllPostsList posts={this.state.posts} clickOnPost={this.clickOnPost}/>
                </Col>
                <Col>
                    {editPost}
                </Col>
            </Row>
        </Container>
    }
}